import { useState } from "react";
import { LeftDrawerContext } from "./LeftDrawerContext";

type LeftDrawerProviderType = {
  children: React.JSX.Element;
};

export const LeftDrawerProvider = ({ children }: LeftDrawerProviderType) => {
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState<React.JSX.Element>(<></>);

  const closeDrawer = () => {
    setOpen(false);
  };

  const openDrawer = (content: React.JSX.Element) => {
    setContent(content);
    setOpen(true);
  };

  return (
    <LeftDrawerContext.Provider
      value={{
        open,
        content,
        closeDrawer,
        openDrawer,
      }}
    >
      {children}
    </LeftDrawerContext.Provider>
  );
};
